export default __webpack_public_path__ + "static/media/raspir.fa2fecb5.svg";